import { useEffect, useRef, useState } from 'react';

const Counter = ({ end, label }) => {
  const ref = useRef(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        let startTime;
        const duration = 1400; // ms

        const animate = (timestamp) => {
          startTime ??= timestamp;
          const progress = Math.min((timestamp - startTime) / duration, 1);
          
          // Easing cubic: 1 - (1 - p)^3
          const eased = 1 - Math.pow(1 - progress, 3);
          setCount(Math.floor(end * eased));

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
        observer.disconnect();
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [end]);

  return (
    <div ref={ref} className="border-white/20 py-5 text-center md:border-l first:border-l-0">
      <div className="text-5xl font-bold text-white md:text-6xl">{count}</div>
      <div className="mt-3 whitespace-pre-line text-xs font-bold uppercase tracking-[.2em] text-[#00a7e2]">
        {label}
      </div>
    </div>
  );
};

const Stats = () => {
  return (
    <section className="relative bg-[#0A2540] py-12">
      <div className="mx-auto grid max-w-6xl grid-cols-1 px-5 md:grid-cols-3">
        <Counter end={47} label="Empleados administrados" />
        <Counter end={326} label="Servicios realizados" />
        <Counter end={20} label="Años de experiencia" />
      </div>
    </section>
  );
};

export default Stats;